/*
 * @Description: 房源维护列表
 * @Author: 段生华
 * @Date: 2019-05-07 17:20:24
 * @LastEditTime: 2019-07-04 11:51:33
 * @LastEditors: Please set LastEditors
 */

import React from 'react';
import {Button, message, Modal, Spin, Upload} from 'antd';
import Cookies from 'js-cookie';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import {postFrom, config, transterQuery, post, uploadNewEnclosure} from '../../axios';
import {formatTime, handleExportParams} from '../../utils';
import JrApiLog from "../Other/JrApiLog";

import {
    API_roomType_batchGeneration,
} from "../../axios/config";
import DeviceNewDetail from "./deviceNewDetail";
import DeviceDetail from "./deviceDetail";


export default class Page extends React.Component {


    constructor() {
        super();
        this.state = {
            loading: false, //页面加载中
            params: { //搜索参数
                keyword: '',
                mustPayDate: '',
                pageSize: 10,
            },
            showBillImportModal:false,  //批量导入账单弹窗
            billImporLoad:false,       //批量导入账单Loading
            billImportData:'',      //批量导入账单 数据显示
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            showAddModal: false, //新增组件弹窗
        }

        let loginData = Cookies.get('loginData');
        if (loginData) { //校验登录是否失效
            loginData = JSON.parse(loginData);
            if (loginData.merchantId) {  //为商户人员添加商户id
                this.merchantId = loginData.merchantId || 0;
            }
        }
    }




    componentDidMount() {
        this.handleSearch();
    }

    handleSearch = (values = {}) => { //表单搜索/分页
        let { params, current } = this.state;
        let data = {};

        if (values.current) {
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        postFrom({ url: config.API_device_findDeviceBillWriteOffPage, data }).then(res => {
            this.setState({ current: res.current, tableTotal: res.total, tableData: res.records, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });
    }

    handleJrApiLogInfo(tableName,id) {
        this.jrApiLogRef.open(tableName,id);
    }


    // importBillProps = {
    //     //批量账单导入
    //     action: config.API_bill_importBill,
    //     accept: '.xls',
    //     data:{ "mustPayDate": ''},
    //     showUploadList: false,
    //     beforeUpload: (file) => {
    //         this.handleSearch()
    //         let { params, current } = this.state;
    //         console.log(params.mustPayDate)
    //         debugger
    //         if(params.mustPayDate===''||params.mustPayDate===null){
    //             message.error('请选择周期月份!');
    //             return false;
    //         }
    //
    //         message.loading(`${file.name}上传中...`);
    //     },
    //     onChange: (info) => {
    //
    //         if (info.file.status === 'done') {
    //             let res = info.file.response;
    //             if (res.code === 0) {
    //                 message.success(`${info.file.name}文件导入成功`);
    //                 if(res.data){
    //                     this.setState({showBillImportModal:true})
    //                     this.handleGetBillImportLog(res.data)
    //                 }
    //             } else {
    //                 if(Array.isArray(res.data)){
    //                     Modal.error({
    //                         className:'importModal',
    //                         title: res.message || `${info.file.name}文件导入失败`,
    //                         content: <div style={{whiteSpace:'pre',maxHeight:'80vh',overflow:'auto'}}>{res.data.join('\n')}</div> ,
    //                     });
    //                 }else{
    //                     message.error(res.message || `${info.file.name}文件导入失败`);
    //                 }
    //             }
    //         } else if (info.file.status === 'error') {
    //             message.error(`${info.file.name}文件上传失败`);
    //         }
    //     },
    // };

    handleGetBillImportLog = (id) => {  //获取批量导入账单的异步进程日志
        this.setState({billImporLoad:true})
        this.billTimer = setInterval(()=>{
            postFrom({ url: config.API_device_getImportLog, data: { threadNo: id, } }).then(res => {
                if (res) {
                    this.setState({billImporLoad:false,billImportData:res.replace(/\\r\\n/g,'\n')})
                } else {
                    message.error(res.message ||  '操作失败!');
                    clearInterval(this.billTimer)
                }
            }).catch(err => {
                message.error(err.message || '操作异常!');
                clearInterval(this.billTimer)
            });
        },2000)
    }

    closeBillImport = ()=>{  //清除 批量账单导入定时器
        clearInterval(this.billTimer)
        this.handleSearch()
        this.setState({showBillImportModal:false})
    }


    handleInfo = (id) => {
        this.DeviceDetailRef.open(id).then(res => {
            this.handleSearch()
        })
    }

    handleNewInfo = (id) => {
        this.DeviceNewDetailRef.open(id).then(res => {
            this.handleSearch()
        })
    }

    postAsyncBatchCheck(id) {
        return post({ url: API_roomType_batchGeneration  +'?id=' + id }).then(() => {
            message.success('批量生成中，请10到20分钟后查看')
        }).catch(e => {
            message.error(e.message)
        })
    }



    handleAsyncBatchCheck() {
        this.postAsyncBatchCheck().then(() =>{
            this.handleSearch()
        })
    }

    uploadContract = (name, res) => { //上传合同照片
        this.setState({showBillImportModal:true})
        this.handleGetBillImportLog(res)
    }

    renderUploadWrap (action,success,data = {}) {
        const uploadConfig = uploadNewEnclosure({
            //批量账单导入
            action: action,
            accept: '.xls',
            tableName: 'rent_contract', success: this.uploadContract, attachType: 5
            // data:{ "mustPayDate": this.state.params.mustPayDate},
           // showUploadList: false,
            // beforeUpload: (file) => {
            //     // message.loading(`${file.name}上传中...`);
            // },
            // onChange: (info) => {
            //     if (info.file.status === 'done') {
            //         let res = info.file.response;
            //         if (res.code === 0) {
            //             message.success(`${info.file.name}文件导入成功`);
            //             if(res.data){
            //                 this.setState({showBillImportModal:true})
            //                 this.handleGetBillImportLog(res.data)
            //             }
            //         } else {
            //             if(Array.isArray(res.data)){
            //                 Modal.error({
            //                     className:'importModal',
            //                     title: res.message || `${info.file.name}文件导入失败`,
            //                     content: <div style={{whiteSpace:'pre',maxHeight:'80vh',overflow:'auto'}}>{res.data.join('\n')}</div> ,
            //                 });
            //             }else{
            //                 message.error(res.message || `${info.file.name}文件导入失败`);
            //             }
            //         }
            //     } else if (info.file.status === 'error') {
            //         message.error(`${info.file.name}文件上传失败`);
            //     }
            // },
        })
        return (
            <Upload {...uploadConfig}>
                <Button type="primary" icon="import">导入设备账单</Button>
            </Upload>
        )
    }

    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            showAddModal,
        } = this.state;
        return (
            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper">
                    <SuperForm
                        data={searchData()}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                    />
                    <div className="search-btn-list">
                        <AuthButton  authkey="z-5-2" type="primary" icon="export" onClick={() => this.handleNewInfo(null) }>核销登记</AuthButton>
                    </div>
                </div>
                <TableDOM
                    columns={columns({ current, handleEdit: this.handleEdit, handleInfo: this.handleInfo,handleNewInfo: this.handleNewInfo,handleJrApiLogInfo:this.handleJrApiLogInfo.bind(this) })}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    current={current}
                    onChange={this.handleSearch}
                    scroll={{x: 1500}}
                />
                {/* 批量账单导入 */}
                <Modal
                    destroyOnClose
                    maskClosable={false}
                    visible={this.state.showBillImportModal}
                    onCancel={this.closeBillImport}
                    footer={<Button onClick={this.closeBillImport} type="primary">确定</Button>}
                >
                    <Spin spinning={this.state.billImporLoad}>
                        <div style={{maxHeight:'80vh',overflow:'auto',padding:'30px',whiteSpace:'pre'}}>
                            {this.state.billImportData}
                        </div>
                    </Spin>
                </Modal>
                <JrApiLog ref={ref=>{
                    this.jrApiLogRef=ref;
                }}/>
                <DeviceNewDetail wrappedComponentRef={ ref=> this.DeviceNewDetailRef  = ref } />
                <DeviceDetail wrappedComponentRef={ ref=> this.DeviceDetailRef  = ref } />
            </PageWrap>
        )
    }


}

const searchData = () => {
    let data =  [
        {
            tagName: 'Input',
            formConfig: { name: 'keyword' },
            attribute: { placeholder: '请输入项目名称', style: { width: '200px' } },
        },
        {
            tagName: 'MonthPicker',
            formConfig: { name: 'mustPayDate' },
            attribute: { placeholder: '请选择周期月份',type:'month',format:"YYYY-MM", style: { width: "172.7px" } },
        }
    ]

    return data;
};

const columns = ({  handleInfo }) => [
    {
        title: '项目名称',
        dataIndex: 'projectName'
    },
    {
        title: '账单周期',
        dataIndex: 'cycleDate'
        ,render: text => formatTime(text, 'YYYY-MM')
    },
    {
        title: '验收日期',
        dataIndex: 'registrationDate',
        render(text) {
            if (!text) return '-'
            return formatTime(text, 'YYYY-MM-DD')
        }
    },
    {
        title: '核销金额',
        dataIndex: 'transferMoney'
    },
    {
        title: '转账日期',
        dataIndex: 'transferDate'
            ,render: text => formatTime(text, 'YYYY-MM-DD')
    },
    {
        title: '创建时间',
        dataIndex: 'createTime',
        render(text) {
            if (!text) return '-'
            return formatTime(text)
        }
    },
    {
        title: '操作',
        dataIndex: 'action',
        width: 200,
        fixed: 'right',
        render(text, record, index) {
            return <span>
              <AuthButton authkey="z-5-3">
                    <a  onClick={() => { handleInfo(record.id) }}>核销明细</a >
                </AuthButton>
            </span>
        }
    }
];


// WEBPACK FOOTER //
// ./src/page/DeviceBillWriteOff/index.jsx